import { createBrowserRouter } from 'react-router';
import { RequireAdmin } from '../features/auth/RequireAdmin';
import { DashboardPage } from '../pages/admin/DashboardPage';
import { HostRoomPage } from '../pages/admin/HostRoomPage';
import { LoginPage } from '../pages/admin/LoginPage';
import { MeetingDetailPage } from '../pages/admin/MeetingDetailPage';
import { MeetingFormPage } from '../pages/admin/MeetingFormPage';
import { TotpPage } from '../pages/admin/TotpPage';
import { GuestPage } from '../pages/guest/GuestPage';
import { HomePage } from '../pages/HomePage';
import { MediaDemoPage } from '../pages/MediaDemoPage';
import { NotFoundPage } from '../pages/NotFoundPage';
import { AdminLayout } from './AdminLayout';

export const router = createBrowserRouter([
  { path: '/', element: <HomePage /> },
  { path: '/admin/connexion', element: <LoginPage /> },
  { path: '/admin/totp', element: <TotpPage /> },
  {
    path: '/admin/reunions/:id/salle',
    element: (
      <RequireAdmin>
        <HostRoomPage />
      </RequireAdmin>
    ),
  },
  {
    path: '/admin',
    element: (
      <RequireAdmin>
        <AdminLayout />
      </RequireAdmin>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'reunions/nouvelle', element: <MeetingFormPage /> },
      { path: 'reunions/:id', element: <MeetingDetailPage /> },
      { path: 'reunions/:id/modifier', element: <MeetingFormPage /> },
    ],
  },
  { path: '/rejoindre', element: <GuestPage /> },
  { path: '/demo-media', element: <MediaDemoPage /> },
  { path: '*', element: <NotFoundPage /> },
]);
